import sensors from '../../sensors';

export default class VideoTrack {
  constructor() {
    this.timer = null;
    this.videoItem = {};
    this.dom = null;
    this._handlerUnload = null;
    this._handlerPlay = null;
    this._handlerPause = null;
    this._handlerEnded = null;
    this.startTime = 0;
    this.playing = false;
  }

  add({ value, dom }) {
    this.offAllEventListener();
    this.clearTimer();
    this.videoItem = { value };
    this.playing = false;
    this.dom = dom;
    this.init();
  }

  offAllEventListener() {
    if (this.dom) {
      this.clearTimer();
      window.removeEventListener("unload", this._handlerUnload);
      this.dom.removeEventListener("play", this._handlerPlay);
      this.dom.removeEventListener("pause", this._handlerPause);
      this.dom.removeEventListener("ended", this._handlerEnded);
    }
  }


  init() {
    this.onPlay();
    this.onPause();
    // this.onEnded();
    this._handlerUnload = this.handlerUnload.bind(this);
    window.addEventListener("unload", this._handlerUnload);
  }

  // 埋直播心跳
  onLive() {
    this.timer = setInterval(() => {
      this.trackLive(this.videoItem.value);
    }, 10 * 1000);
  }
  clearTimer() {
    clearInterval(this.timer);
  }

// 直播心跳
trackLive(value) {
  if (sensors.instance) {
    const {
      content_id,
      content_name,
      content_form,
      live_status,
    } = value;
    const data = {
      content_id,
      content_name,
      content_form,
      live_status,
    };
    sensors.instance.track("ContentLiveOnShow", {
      ...data,
    });
  }
}

  onPlay() {
    if (this.dom) {
      this._handlerPlay = this.handlerPlay.bind(this);
      this.dom.addEventListener("play", this._handlerPlay);
    }
  }

  onPause() {
    if (this.dom) {
      this._handlerPause = this.handlerPause.bind(this);
      this.dom.addEventListener("pause", this._handlerPause);
    }
  }

  onEnded() {
    if (this.dom) {
      this._handlerEnded = this.handlerEnded.bind(this);
      this.dom.addEventListener("ended", this._handlerEnded);
    }
  }

  // 开始播放上报
  trackStart(value) {
    if (sensors.instance) {
      sensors.instance.track("ContentVideoStart", {
        ...value,
      });
    }
  }

  // 结束\暂停播放上报
  trackEnd(value) {
    if (sensors.instance) {
      console.log("~~暂停或结束埋点ended");
      const t = new Date().getTime() - this.startTime;
      sensors.instance.track("ContentVideoEnd", {
        ...value,
        play_duration: Math.floor(t / 1000),
      });
    }
  }

  handlerUnload() {
    this.clearTimer();
    if (this.playing) {
      // 测试是否关闭页面会保存本地数据
      // localStorage.setItem(
      //   new Date().getTime() + "video-ContentVideoEnd",
      //   JSON.stringify({
      //     ...this.videoItem.value,
      //     play_duration: Math.ceil(
      //       (new Date().getTime() - this.startTime) / 1000
      //     ),
      //   })
      // );
      this.handlerEnded();
    }
  }

  handlerPlay() {
    this.startTime = new Date().getTime();
    // console.log("~play");
    this.playing = true;
    //console.log('~~~~~~',this.videoItem.value.live_status)
    if (
      this.videoItem.value.live_status == 1 
    ) {
      this.onLive();
    }
    this.trackStart(this.videoItem.value);
  }
    

  handlerPause() {
    // if (this.dom.currentTime < this.dom.duration) {
    //   console.log("pause");
    //   this.playing = false;
    //   this.trackEnd(this.videoItem.value);
    // }
    console.log('~~~~~~~暂停了视频')
    this.clearTimer();
    this.playing = false;
    this.trackEnd(this.videoItem.value);
  }

  handlerEnded() {
    this.clearTimer();
    console.log("~~视频播放结束ended");
    this.playing = false;
    this.trackEnd(this.videoItem.value);
  }
}
